import { createContext, useContext, useState } from "react";

// Création du contexte
const SectionContext = createContext();

// Hook perso pour l'utiliser facilement
export const useSection = () => useContext(SectionContext);

// Provider pour englober l'app
export const SectionProvider = ({ children }) => {
  const [activeSection, setActiveSection] = useState("banners");

  return (
    <SectionContext.Provider value={{ activeSection, setActiveSection }}>
      {children}
    </SectionContext.Provider>
  );
};
